import { useApiPrivateRequest } from "../../../shared/hooks/useApi";

export const useRenameChat = (chatId: string) => {
  const { isFailed, isLoading, call } = useApiPrivateRequest<void>();
  const renameChat = async (name: string) => {
    await call(`/chats/${chatId}/rename`, "PUT", undefined, { name });
  };
  return { isFailed, isLoading, renameChat };
};
